import { useGlobalContext } from '../context';

const Score = () => {
  const { score, lessonState } = useGlobalContext();

  return (
    <div className="fs-500">
      Score:{' '}
      <span
        className="fs-600"
        style={{
          backgroundColor: score < 0 ? 'gold' : 'hsl(var(--clr-light))',
          color: score < 0 ? 'red' : 'hsl(var(--clr-dark))',
          display: 'inline-block',
          textAlign: 'center',
          width: '100px',
          height: '60px',
          paddingTop: '10px',
          borderRadius: '6%',
        }}
      >
        {score}{' '}
      </span>{' '}
      <hr />
      {score >= 100 * lessonState && lessonState !== 0 && (
        <div
          className="fs-200  "
          style={{ color: 'green', fontWeight: 'bold' }}
        >
          {' '}
          Next lesson maybe?{' '}
        </div>
      )}
    </div>
  );
};

export default Score;
